import { CSSProperties } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import CategoryProfileMenu from "./sections/Menu/Menu";
import CategoryProfileTrendingNow from "./sections/TrendingNow/TrendingNow";
import CategoryProfileLaunches from "./sections/Launches/Launches";
import CategoryProfileConsumer from "./sections/Consumer/Consumer";
import CategoryProfileBrandPerformance from "./sections/BrandPerformance/BrandPerformance";
import CategoryProfileReports from "./sections/Reports/Reports";

export enum CategoryProfileSectionId {
    TrendingNow = 'trending-now',
    Menu = 'menu',
    Consumer = 'consumer',
    Launches = 'launches',
    BrandPerformance = 'brand-performance',
    Reports = 'reports',
}

export interface CategoryProfileSectionComponentProps {
    title: string;
    categoryName: string;
    data?: unknown;
}

export interface CategoryProfileSectionDataState {
    hasData: boolean;
    isLoading: boolean;
    data?: unknown;
}

export interface CategoryProfileSection {
    id: CategoryProfileSectionId;
    title: string;
    Component: FCX<CategoryProfileSectionComponentProps>;
}

export const DEFAULT_CATEGORY_PROFILE_SECTION_STATE: CategoryProfileSectionDataState = {
    hasData: false,
    isLoading: false,
    data: undefined,
};

export const CATEGORY_PROFILE_SECTIONS: CategoryProfileSection[] = [
    {
        id: CategoryProfileSectionId.TrendingNow,
        title: 'Trending Now',
        Component: CategoryProfileTrendingNow,
    },
    {
        id: CategoryProfileSectionId.Menu,
        title: 'Menu',
        Component: CategoryProfileMenu,
    },
    {
        id: CategoryProfileSectionId.Consumer,
        title: 'Consumer',
        Component: CategoryProfileConsumer,
    },
    {
        id: CategoryProfileSectionId.Launches,
        title: 'Launches',
        Component: CategoryProfileLaunches,
    },
    {
        id: CategoryProfileSectionId.BrandPerformance,
        title: 'Brand Performance',
        Component: CategoryProfileBrandPerformance,
    },
    {
        id: CategoryProfileSectionId.Reports,
        title: 'Read About It',
        Component: CategoryProfileReports,
    },
];

export const CATEGORY_PROFILE_SCROLLBAR_ID = 'CategoryProfileScrollbar';
export const CATEGORY_PROFILE_HEADER_HEIGHT = 60;
const CATEGORY_NAVIGATION_HEIGHT = 56;
const CATEGORY_STICKY_OFFSET = 24;
export const CATEGORY_PROFILE_TAB_OFFSET = CATEGORY_NAVIGATION_HEIGHT + CATEGORY_STICKY_OFFSET;

export const CATEGORY_PROFILE_CSS_VARS = {
    '--category-header-height': `${CATEGORY_PROFILE_HEADER_HEIGHT}px`,
    '--category-navigation-height': `${CATEGORY_NAVIGATION_HEIGHT}px`,
    '--category-sticky-offset': `${CATEGORY_STICKY_OFFSET}px`,
    '--category-sticky-top': `${CATEGORY_PROFILE_TAB_OFFSET}px`,
} as CSSProperties;
